import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { PersistGate } from "redux-persist/integration/react";
import "@/src/auth";
import "@/src/notifications";
import "@/src/settings";
import { AppThemeProvider } from "@/src/common/contexts/theme-provider";
import { rootRouter } from "@/src/common/navigations/root-router";
import { persistor, store } from "@/src/common/redux/store";

export function App() {
	return (
		<HelmetProvider>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<AppThemeProvider>
						<Suspense fallback={null}>
							<RouterProvider router={rootRouter} />
						</Suspense>
					</AppThemeProvider>
				</PersistGate>
			</Provider>
		</HelmetProvider>
	);
}
